module.exports = "<div class=\"footer\"><!-- <img src=\"../../assets/Icon-QuestionMark.svg\" alt=\"support chat\"> --></div>\n"